import get from 'lodash/get';
import RestClient from '../RestClient/RestClient';
import { getCookie } from '../helpers/Cookies';

function getValuesFromCookie(mboxCookie) {
    // PC#876a7b89c3b441f6a0b8798e4d0fcb70.28_16#1621288956|session#a0286a4a15754a7db01095d00a05fb3b#1558046016
    // session#eaa62341e2a44b9282e216279511b440#1558103994|PC#eaa62341e2a44b9282e216279511b440.28_45#1621346934
    const mboxValues = mboxCookie.split('|');
    const result = {
        session: '',
        PC: '',
    };
    mboxValues &&
        mboxValues.forEach((mboxValue) => {
            if (mboxValue.startsWith('session')) {
                result.session = mboxValue.split('#')[1];
            }

            if (mboxValue.startsWith('PC')) {
                result.PC = mboxValue.split('#')[1];
            }
        });

    return result;
}

function getURLParameterBykey(key) {
    let name = key;
    const url = window && window.location && `${window.location.search}`;
    name = name.replace(/[[\]]/g, '\\$&');
    const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
    const results = regex.exec(url);
    /* istanbul ignore else */
    if (!results) return null;
    /* istanbul ignore else */
    if (!results[2]) return '';
    // While passing to search page, blank space are replaced by +
    // So when we get the value, + is replaced by blankspace
    return decodeURIComponent(results[2].replace(/\+/g, '_'));
}

function constructUrl(initialData, slotId) {
    // const recommendationUrl = 'https://jcpenney.tt.omtrdc.net/m2/jcpenney/ubox/raw';
    const recommendationUrl = 'https://ttmetrics.jcpenney.com/m2/jcpenney/ubox/raw';
    const queryParams = [];
    const {
        attributes = {},
        pageType = '',
        enableMboxEntityParamsInCart = false,
    } = initialData.payload;
    slotId && queryParams.push(`mbox=${slotId}`);
    let entityKey = 'entity.id=';
    const customerId = 'profile.uid=';
    const categoryIdKey = 'entity.categoryId=';
    const { departmentid, itemid } = attributes;
    const isPageTypeSearch = pageType && pageType === 'SEARCH';
    const isPageTypeCategory = pageType && pageType === 'CATEGORY';
    const isPageTypeCart = pageType && (pageType === 'cart1' || pageType === 'cart2');
    const itemids =
        itemid &&
        (isPageTypeSearch || isPageTypeCategory
            ? itemid.split(';')[0]
            : itemid.split(';').join(','));
    const getGalleryCategoryId = getURLParameterBykey('id');
    const galleryCategoryid =
        isPageTypeCategory && getGalleryCategoryId ? getGalleryCategoryId : null;

    if (isPageTypeSearch) {
        entityKey = 'productEntityID=';
    } else if (departmentid) {
        queryParams.push(`${categoryIdKey}${departmentid}`);
        queryParams.push('entity.event.detailsOnly=true');
    } else if (galleryCategoryid) {
        queryParams.push(`${categoryIdKey}${galleryCategoryid}`);
        entityKey = 'productEntityID=';
    }
    /* MCYODA-23675 => Cart | Update mBox Parameters */
    if (isPageTypeCart && enableMboxEntityParamsInCart) {
        entityKey = 'productEntityID=';
    }

    if (itemids) {
        queryParams.push(`${entityKey}${itemids}`);
    }
    const adobeScheme = get(initialData, 'payload.adobeScheme', []);
    /* istanbul ignore else */
    if (adobeScheme.indexOf(slotId) > -1) {
        const accountID = getCookie('ACCOUNT_ID');
        if (accountID) {
            queryParams.push(`${customerId}${accountID}`);
        }
    }

    // Adding all remianing keys as params
    const keys = Object.keys(attributes);
    keys.forEach((key) => {
        if (
            key !== 'pagetype' &&
            key !== 'departmentid' &&
            key !== 'categoryid' &&
            key !== 'itemid'
        ) {
            queryParams.push(`${key}=${attributes[key]}`);
        }
    });

    const { hostname, href } = window.location;
    queryParams.push('mboxContentType=application/json');
    const mboxCookie = getCookie('mbox');
    /* istanbul ignore else */
    if (mboxCookie) {
        const values = getValuesFromCookie(mboxCookie);
        if (values.session) {
            queryParams.push(`mboxSession=${values.session}`);
        }

        if (values.PC) {
            queryParams.push(`mboxPC=${values.PC}`);
        }
    }
    queryParams.push('mboxDefault=%7B%7D');
    queryParams.push('mboxXDomain=disable');
    queryParams.push('mboxNoRedirect=true');
    queryParams.push(`mboxHost=${hostname}`);
    /* istanbul ignore next */
    if (window.visitor) {
        const mcsdId = window.visitor._supplementalDataIDCurrent;
        if (mcsdId) {
            queryParams.push(`mboxMCSDID=${mcsdId}`);
        }
    }

    queryParams.push(`mboxURL=${encodeURIComponent(href)}`);

    return `${recommendationUrl}?${queryParams.join('&')}`;
}

export const getRecommendationFromAdobe = (slotId, initialData) => {
    const emptyResult = [{ scheme: slotId, display: 'no' }];
    try {
        const config = {
            external: true,
            url: constructUrl(initialData, slotId),
            referrerPolicy: 'no-referrer-when-downgrade',
        };
        return RestClient.get(config).then((json) => {
            if (typeof json === 'object') {
                const schemes = get(json, 'data.resonance.schemes');
                return schemes || emptyResult;
            }
            return emptyResult;
        });
    } catch (e) {
        /* istanbul ignore next */
        return emptyResult;
    }
};

function fetchAllSchemes(resolve, initialData) {
    const allScheme = get(initialData, 'payload.attributes.schemes', '');
    const slots = allScheme.split(';');
    const adobeScheme = get(initialData, 'payload.adobeScheme', []);
    const isLoggedIn = get(initialData, 'payload.isLoggedIn', false);
    const modifiedSlots = slots.filter((elm) => adobeScheme.indexOf(elm) === -1); // adobeScheme is coming from the config preference.recommendation.adobeScheme this is added to differiante stragegy provider
    const slotsData = isLoggedIn ? slots : modifiedSlots;
    const recommendations = slotsData.map((slot) => getRecommendationFromAdobe(slot, initialData));

    return Promise.all(recommendations).then((schemeList) => {
        let schemesData = [];
        schemeList &&
            schemeList.forEach((schemes) => {
                /* istanbul ignore else */
                if (schemes) {
                    schemesData = schemesData.concat(schemes);
                }
            });
        resolve({ schemes: schemesData });
    });
}

export const getRecommendationDataFromAdobe = (initialData) => {
    if (!__SERVER__) {
        return new Promise((resolve) => fetchAllSchemes(resolve, initialData));
    }
};
